import axios from 'axios'

const swagger = {
  state: () => ({
    spec: null,
  }),

  getters: {
    getSpec: (state) => {
      return state.spec
    }
  },

  mutations: {
    SET_SWAGGER_SPEC: (state, spec) => {
      state.spec = spec
    },
  },
  actions: {
    GetSwaggerSpec (context) {
      let path = `swagger`
      return axios.get(path)
        .then((response) => {
          context.commit('SET_SWAGGER_SPEC', response.data)
        })
    }
  }
}

export default swagger
